export const setJoinCommunity = (isJoinCommunity) => ({
    type: "SET_JOIN_COMMUNITY",
    payload: { isJoinCommunity },
  });
  